export default __webpack_public_path__ + "static/media/post-11.a1ad1c17.jpg";